import React, {useEffect, useState, useRef} from 'react'
import { Button, Box, CircularProgress } from '@mui/material';
import { green } from '@mui/material/colors';

function SubmitButton({createUser, state}) {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const timer = useRef();

    //Buttons
    const buttonSx = {
        width: "100%",
        height: "50px",
        ...(success && {
            bgcolor: green[500],
            '&:hover': {
                bgcolor: green[700],
            },
        }),
    };

    useEffect(() => {
        return () => {
            clearTimeout(timer.current);
        };
    }, []);

    const handleButtonClick = () => {
        if (!loading) {
            setSuccess(false);
            setLoading(true);
            if(createUser()) {
                timer.current = window.setTimeout(() => {
                    setSuccess(true);
                    setLoading(false);
                }, 2000);
            }
        }
    };

    function DisabledButton() {
        if(state.terms_of_service == true) {
            return (
                <Button
                variant="contained"
                sx={buttonSx}
                disabled={loading}
                onClick={handleButtonClick}
            >
                Submit
            </Button>
            )
        } else {
            return (
                <Button
                variant="contained"
                sx={buttonSx}
                disabled
                onClick={handleButtonClick}
            >
                Submit
            </Button>
            )
        }
    }

    console.log(success)

    if(success === true) {
        window.location.href = "https://eterna-life.com/pages/questionnaire-submitted";
    }

    return (
        <Box sx={{ position: 'relative' }}>
            <DisabledButton />
            {loading && (
                <CircularProgress
                    size={24}
                    sx={{
                        color: green[500],
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px',
                    }}
                />
            )}
        </Box>
    )
}

export default SubmitButton